function copyProductData(
  selectedSourceAssortiment = "",
  selectedSourceCollection = "",
  selectedDestinationAssortiment = "",
  selectedDestinationCollection = "",
  sourceLangCode = "nl-NL",
  destinationLangCode = "en-EN",
  copy = []
) {
  if (
    selectedSourceAssortiment !== "" &&
    selectedSourceCollection !== "" &&
    selectedDestinationAssortiment !== "" &&
    selectedDestinationCollection !== ""
  ) {
    // get source product data
    const sourceLang = sourceLangCode.split("-");
    console.log("Selected source Localization = " + sourceLang[0]);

    const sourceData = getProductData(
      selectedSourceAssortiment,
      selectedSourceCollection,
      "",
      sourceLang[0]
    );

    if (typeof sourceData !== "object") {
      return sourceData.replaceAll(
        "getProductData",
        "copyProductData - cant find source module"
      );
    }

    console.log("Source data:");
    console.log(sourceData);

    // get destination product data
    const destinationLang = destinationLangCode.split("-");
    console.log("Selected destination Localization = " + destinationLang[0]);

    const destinationData = getProductData(
      selectedDestinationAssortiment,
      selectedDestinationCollection,
      "",
      destinationLang[0]
    );

    if (typeof destinationData !== "object") {
      return destinationData.replaceAll(
        "getProductData",
        "copyProductData - cant find destination module"
      );
    }

    console.log("Destination data:");
    console.log(destinationData);

    if (sourceData.length !== destinationData.length) {
      return "Error: copyProductData cant copy, source and destination data have diffrent size.";
    }

    let nrOfmodifies = 0;

    // copy data from source to detination
    for (let sourceIndex in sourceData) {
      let copiedData = false;
      for (let desIndex in destinationData) {
        if (
          destinationData[desIndex].productCode ===
          sourceData[sourceIndex].productCode
        ) {
          for (let copyIndex in copy) {
            let propertie = copy[copyIndex];
            destinationData[desIndex][propertie] =
              sourceData[sourceIndex][propertie];
            // end copy loop
          }
          nrOfmodifies++;
          copiedData = true;
        }
        // end destination data loop
      }
      if (!copiedData) {
        console.log(
          `Could not find: ${sourceData[sourceIndex].productCode} in destination data.`
        );
      }
      // end sourcedata loop
    }

    console.log(
      `Copied ${nrOfmodifies} of ${destinationData.length}/${sourceData.length} products.`
    );

    console.log("Output data:");
    console.log(destinationData);

    return display(destinationData);
  }
  // end copyProductData
}

function getProductData(
  selectedAssortiment = undefined,
  selectedCollection = undefined,
  displayProduct = "",
  langCode = "en-EN"
) {
  if (typeof selectedAssortiment === "string" && selectedAssortiment !== "") {
    if (typeof selectedCollection === "string" && selectedCollection !== "") {
      if (typeof langCode === "string" && langCode !== "") {
        // get localization
        const lang = langCode.split("-");

        // get Tiles from json
        try {
          const data = require("@/assets/products/json/" +
            lang[0] +
            "/" +
            selectedAssortiment.toLowerCase() +
            "/" +
            selectedCollection.toLowerCase());

          let productJson = [];
          let iProduct = 0;

          if (typeof displayProduct === "string" && displayProduct !== "") {
            for (const products in data) {
              if (data[products].naam === displayProduct) {
                productJson[iProduct] = data[products];
                iProduct++;
              }
            }
          } else {
            productJson = data;
          }

          return productJson;
        } catch (e) {
          // on error
          return `Error: could not find module: "@/assets/products/json/"${
            lang[0]
          }/${selectedAssortiment.toLowerCase()}/${selectedCollection.toLowerCase()}.`;
        }
      } else {
        return "Error: input parameter 4 of function getProductData is not of type string or empty.";
      }
    } else {
      return "Error: input parameter 2 of function getProductData is not of type string or empty.";
    }
  } else {
    return "Error: input parameter 1 of function getProductData is not of type string or empty.";
  }
  // end getProductData
}

// console.log(getProductData("vin","safe-tex","Safe Tex R11","nl-NL"))

function display(productJson) {
  let productText = "[  ";

  if (typeof productJson === "object") {
    for (const products in productJson) {
      for (const propertie in productJson[products]) {
        // handle values from product object
        let value = '""';

        // if value is an general object
        if (typeof productJson[products][propertie] === "object") {
          // if value is an array
          if (Array.isArray(productJson[products][propertie])) {
            value = "[";
            for (let index in productJson[products][propertie]) {
              if (
                Number(index) + 1 ==
                productJson[products][propertie].length
              ) {
                if (
                  typeof productJson[products][propertie][index] === "number"
                ) {
                  value += `${productJson[products][propertie][index]}`;
                } else if (
                  typeof productJson[products][propertie][index] === "string"
                ) {
                  value += `"${productJson[products][propertie][index]}"`;
                }
              } else {
                if (
                  typeof productJson[products][propertie][index] === "number"
                ) {
                  value += `${productJson[products][propertie][index]},`;
                } else if (
                  typeof productJson[products][propertie][index] === "string"
                ) {
                  value += `"${productJson[products][propertie][index]}",`;
                }
              }
            }

            value += "]";
          }
          // if value is object
          else {
            let valueObject = productJson[products][propertie];
            for (let valueKey in valueObject) {
              if (Object.keys(valueObject).length === 1) {
                value = `{"${valueKey}":"${valueObject[valueKey]}"}`;
              } else if (Object.keys(valueObject).indexOf(valueKey) === 0) {
                value = `{"${valueKey}":"${valueObject[valueKey]}"`;
              } else if (
                Object.keys(valueObject).indexOf(valueKey) ===
                Object.keys(valueObject).length - 1
              ) {
                value += `,"${valueKey}":"${valueObject[valueKey]}"}`;
              } else {
                value += `,"${valueKey}":"${valueObject[valueKey]}"`;
              }
              // end valueObject loop
            }
          }
        }
        // if value is string
        else if (typeof productJson[products][propertie] === "string") {
          value = `"${productJson[products][propertie]}"`;
        }
        // if value is number
        else if (typeof productJson[products][propertie] === "number") {
          value = Number(productJson[products][propertie]);
        }

        // build product object
        // start of product object
        if (Object.keys(productJson[products]).indexOf(propertie) === 0) {
          productText += `\n\t{\n\t\t"${propertie}":${value},\n`;
        }
        // end of product object
        else if (
          Object.keys(productJson[products]).indexOf(propertie) ===
          Object.keys(productJson[products]).length - 1
        ) {
          if (productJson.length - 1 == products) {
            productText += `\t\t"${propertie}":${value}\n\t}`;
          } else {
            productText += `\t\t"${propertie}":${value}\n\t},`;
          }
        }
        // inbetween of product object
        else {
          productText += `\t\t"${propertie}":${value},\n`;
        }
        // einde propertie loop
      }
      // einde product loop
    }
    return productText + "\n]";
  }
  return "error: input parameter 1 of function display is not of type object.";
  // end display
}

function displayProductData(
  selectedAssortiment = "",
  selectedCollection = "",
  displayProduct = "",
  langCode = "en-EN"
) {
  const productJson = getProductData(
    selectedAssortiment,
    selectedCollection,
    displayProduct,
    langCode
  );

  if (typeof productJson === "object") {
    return display(productJson);
  } else {
    // on error
    const errorMsg = productJson.replaceAll(
      "getProductData",
      "displayProductData"
    );

    return errorMsg;
  }
  // end displayProductData
}

// console.log(displayProductData("vin","safe-tex","Safe Tex R11","nl-NL"))

function addKey(
  selectedAssortiment = "",
  selectedCollection = "",
  modifyProduct = "",
  langCode = "en-EN",
  newKey = "",
  value = ""
) {
  let productJson = getProductData(
    selectedAssortiment,
    selectedCollection,
    modifyProduct,
    langCode
  );

  if (typeof productJson === "object") {
    if (newKey !== "" && typeof newKey === "string") {
      if (Object.keys(productJson).includes(newKey) === false) {
        for (let index in productJson) {
          productJson[index][newKey] = value;
        }
      }
    }
    return display(productJson);
  } else {
    // on error
    const errorMsg = productJson.replaceAll("getProductData", "addKey");

    return errorMsg;
  }
  // end addKey
}

// console.log(addKey("vin","safe-tex","Safe Tex R11","nl-NL", "dikte", "test"))

const json = {
  copyProductData,
  display,
  displayProductData,
  getProductData,
  addKey,
};

export default json;
